"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetch = exports.loadLocalMockStore = exports.getLocalMockStore = exports.removeLocalMockStore = exports.setLocalMockStore = exports.getLocalMockEnabled = exports.setLocalMockEnabled = exports.stopPropagation = exports.initializeLocalMock = exports.sortedKeys = exports.localMockStore = void 0;
const local_mock_constants_1 = require("./local-mock.constants");
const originalFetch = window.fetch;
const LOCAL_MOCK_ENABLED = 'LOCAL_MOCK_ENABLED';
const LOCAL_MOCK_STORE = 'LOCAL_MOCK_STORE';
const KEY_REGEX = /^\.\/(.*)\/([^/.]*)(?:\.(.*))?\.mock\.(?:js|ts)$/;
const URL_REGEX = /([^?]*)\??(.*)/;
const PATH_CONST_REGEX = /\[([^\]]+)\]/g;
const PATH_VAR_REGEX = /\{([^}]+)\}/;
const TRAIL_SLASH_REGEX = /\/$/;
const initialState = {
    enabled: false,
    selected: 'default',
    status: 200,
};
let localMock;
function initializeLocalMock(context) {
    exports.localMockStore = loadLocalMockStore(context);
    exports.sortedKeys = Object.keys(exports.localMockStore).sort((a, b) => a.slice(a.indexOf(' ') + 1).localeCompare(b.slice(b.indexOf(' ') + 1)));
    return true;
}
exports.initializeLocalMock = initializeLocalMock;
function stopPropagation(event) {
    event.stopPropagation();
}
exports.stopPropagation = stopPropagation;
function setLocalMockEnabled(value) {
    localStorage.setItem(LOCAL_MOCK_ENABLED, JSON.stringify(value));
}
exports.setLocalMockEnabled = setLocalMockEnabled;
function getLocalMockEnabled() {
    const localMockEnabled = localStorage.getItem(LOCAL_MOCK_ENABLED);
    if (localMockEnabled) {
        return JSON.parse(localMockEnabled);
    }
    return false;
}
exports.getLocalMockEnabled = getLocalMockEnabled;
function setLocalMockStore(value) {
    localMock = value;
    localStorage.setItem(LOCAL_MOCK_STORE, JSON.stringify(value));
}
exports.setLocalMockStore = setLocalMockStore;
function removeLocalMockStore() {
    localStorage.removeItem(LOCAL_MOCK_STORE);
}
exports.removeLocalMockStore = removeLocalMockStore;
function getLocalMockStore() {
    const _localMockStore = localStorage.getItem(LOCAL_MOCK_STORE);
    if (_localMockStore) {
        localMock = JSON.parse(_localMockStore);
        return localMock;
    }
    return null;
}
exports.getLocalMockStore = getLocalMockStore;
function addKeys(r) {
    return (acc, key) => {
        const [, path, method, country] = key.match(KEY_REGEX);
        const pathWithMethod = `${method.toUpperCase()} ${path}`;
        if (country === window.COUNTRY || (!country && !acc[pathWithMethod])) {
            acc[pathWithMethod] = { ...r(key), [local_mock_constants_1.STATE]: initialState };
        }
        return acc;
    };
}
function loadLocalMockStore(context) {
    let _localMockStore = getLocalMockStore();
    if (!_localMockStore) {
        _localMockStore = context.keys().reduce(addKeys(context), {});
        setLocalMockStore(_localMockStore);
    }
    return _localMockStore;
}
exports.loadLocalMockStore = loadLocalMockStore;
function compareElements(urlElements, pathElements) {
    const vars = {};
    const indexes = [];
    for (let index = 0; index < urlElements.length; index++) {
        const urlElement = urlElements[index];
        const pathElement = pathElements[index];
        const urlElementMatch = urlElement.match(PATH_VAR_REGEX);
        if (!urlElementMatch && urlElement !== pathElement) {
            return {};
        }
        if (urlElementMatch) {
            vars[urlElementMatch[1]] = pathElement.slice(pathElement.indexOf(' ') + 1);
            indexes.push(index);
        }
    }
    return { vars, indexes };
}
function findUrl(urls, path) {
    const { key, vars } = Object.keys(urls).reduce((acc, url) => {
        if (!url.match(PATH_VAR_REGEX)) {
            return acc;
        }
        const urlElements = url.split('/');
        const pathElements = path.split('/');
        if (urlElements.length !== pathElements.length) {
            return acc;
        }
        const { vars: comparedVars, indexes } = compareElements(urlElements, pathElements);
        if (!comparedVars) {
            return acc;
        }
        if (!acc.indexes.some((index, i) => index > indexes[i])) {
            acc.key = urls[url];
            acc.vars = comparedVars;
            acc.indexes = indexes;
        }
        return acc;
    }, { key: undefined, vars: {}, indexes: [] });
    return { key, vars };
}
function getPath(args) {
    const [url, { method = 'get' } = {}] = args;
    const [, pathWithoutQuery] = url.match(URL_REGEX);
    return `${method.toUpperCase()} ${pathWithoutQuery.replace(TRAIL_SLASH_REGEX, '')}`;
}
function replaceConstants(path, constants) {
    return path.replace(PATH_CONST_REGEX, (_, p1) => {
        return constants[p1] || p1;
    });
}
function addUrls(constants) {
    return (acc, url) => {
        const replacedUrl = replaceConstants(url, constants);
        acc[replacedUrl] = url;
        return acc;
    };
}
// eslint-disable-next-line @typescript-eslint/ban-types
function getResponse(mockResponse, vars) {
    const response = typeof mockResponse === 'string' && mockResponse.startsWith('function')
        ? new Function('args', `return ${mockResponse}(args)`)(vars)
        : mockResponse;
    return response;
}
function logMock(path, key, headers, body, state, response, ...args) {
    /* eslint-disable no-console */
    console.group(`API ${path}`);
    console.log('API', key);
    headers && console.log('API headers', args[0]);
    body && console.log('API body', typeof body === 'string' ? JSON.parse(body) : body);
    console.log('API status', state.status);
    console.log('API response', response);
    console.log(`API ${path}`);
    console.groupEnd();
    /* eslint-enable no-console */
}
function getMock(path, urls) {
    let key = urls[path];
    let vars;
    if (!key) {
        const result = findUrl(urls, path);
        key = result.key;
        vars = result.vars;
    }
    return { key, vars };
}
function fetch(constants) {
    const urls = Object.keys(localMock).reduce(addUrls(constants), {});
    return async (...args) => {
        if (getLocalMockEnabled()) {
            const { headers, body } = args[1] || {};
            const path = getPath(args);
            const { key, vars } = getMock(path, urls);
            const { [local_mock_constants_1.STATE]: state, ...mock } = localMock[key] || {};
            if (!state?.enabled) {
                return originalFetch(...args);
            }
            const mockResponse = mock[state.selected];
            const response = getResponse(mockResponse, vars);
            logMock(path, key, headers, body, state, response, ...args);
            return new Response(new Blob([typeof response === 'string' ? response : JSON.stringify(response)]), { status: state.status });
        }
        return originalFetch(...args);
    };
}
exports.fetch = fetch;
//# sourceMappingURL=local-mock.util.js.map